import { render, staticRenderFns } from "./VoucherAndRoomInformationRoomType.vue?vue&type=template&id=a0154858&scoped=true"
import script from "./VoucherAndRoomInformationRoomType.vue?vue&type=script&lang=js"
export * from "./VoucherAndRoomInformationRoomType.vue?vue&type=script&lang=js"
import style0 from "./VoucherAndRoomInformationRoomType.vue?vue&type=style&index=0&id=a0154858&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0154858",
  null
  
)

export default component.exports